import { useMemo } from 'react';
import { Cube, Eye, Truck } from '@phosphor-icons/react';
import styled from 'styled-components';
import { CommonUtility, theme } from '../../../utility';
import { HeaderText, MuteBorder, MuteText, ShadowBox } from '../../../elements';
import { ItemImage } from '../../../components';

const ItemsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

const TitleContainer = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
`;

const FileHref = styled.a`
  display: flex;
  align-items: center;
`;

export function PalletContainerItems({ items }) {
  const shippedItems = useMemo(() => {
    if (CommonUtility.isValidArray(items)) {
      return items?.filter(x => x.status === 'shipped');
    }
    return [];
  }, [items]);

  return (
    <ShadowBox>
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <Truck size={24} color={theme.colors.grey} />
          <HeaderText className="mx-1">Fulfilled</HeaderText>
        </div>
        <div className="d-flex align-items-center">
          <Cube color={theme.colors.grey} size={20} />
          <MuteText className="ml-2">{shippedItems?.length} Items</MuteText>
        </div>
      </div>
      <ItemsContainer>
        {shippedItems?.map((item, index) => (
          <>
            <div
              key={item._id}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <ItemImage
                  imageKey="p_images"
                  displayImageKey="display_image"
                  item={item?.productId}
                  size="mini"
                />
                <div className="d-flex flex-column ml-2">
                  <TitleContainer>{item?.productId?.p_title}</TitleContainer>
                  <div className="d-flex">
                    <MuteText>SKU</MuteText>
                    <span className="ml-2">{item?.productId?.p_sku}</span>
                  </div>
                  <div className="d-flex">
                    <MuteText>UPC</MuteText>
                    <span className="ml-2">{item?.productId?.upc}</span>
                  </div>
                </div>
              </div>
              <div className="d-flex mx-2">
                <MuteText className="mr-2">Order</MuteText>
                <span>{item.order?.marketplace_order_display_id}</span>
              </div>
              <FileHref href={item.shipping?.labels?.[0]?.url} download target="_blank">
                <Eye className="mr-2" size={18} />
                <span>View Label</span>
              </FileHref>
            </div>
            {index !== shippedItems?.length - 1 && <MuteBorder />}
          </>
        ))}
      </ItemsContainer>
    </ShadowBox>
  );
}
